module.exports = __webpack_public_path__ + "img/loader.a3fbbe9a.gif";